<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form class="form" :model="self_form" :rules="rules" ref="form" label-width="12%">
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>商品类型</span>
        </div>
        <div class="conf">
            <el-form-item label="商品类型：">
            <el-radio-group v-model="self_mtRapidType">
              <el-radio :label="2" border>非药类</el-radio>
              <el-radio :label="1" border>医药类</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="!self_form.upc && self_mtRapidType == 1">
            <el-alert
              title=""
              type="error">
              商家仅能上传美团药品标品库里已存在的商品，且不支持创建标品，请商家 
              <span style="color:blue;cursor: pointer;" @click="handleDownProduct">下载商品</span>
              后，上架药品至其他美团健康医药店铺
            </el-alert>
          </el-form-item>
          </div>
      </section>
      <template v-if="self_form.upc || self_mtRapidType == 2">
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item v-if="self_mtRapidType == 1" label="">
            <!-- <div class="" style="display:flex;">
              <el-input v-model="self_form.upcCode"  placeholder="请输入UPC编码"></el-input>
              <el-button @click="handleMatchUPC" type="primary" style="margin-left: 8px;">匹配</el-button>
            </div> -->
          </el-form-item>
          <el-form-item label="商品名称：" prop="name">
            <el-input :disabled="self_mtRapidType == 1" type="text" placeholder="请输入" 
              v-model="self_form.name" show-word-limit> 
               <span slot="suffix" style="margin-right: 6px;">{{titleLength}}/60</span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <span>建议命名形式为“品牌+品名+售卖规则，<a>示例：</a> 【敷尔佳】敷尔佳清痘净肤修护贴26g*5贴/盒，规范命名有利于提升销量”，</span>
              <a target="_blank" href="https://collegewm.meituan.com/sg/post/detail?id=144&contentType=0">查看命名规范</a>
            </div>
            <div style="display:flex;">
              <span style="white-space:nowrap;margin-right: 4px;">商品名称补充语 </span>
              <div>
                <el-input clearable v-model="self_form.productNameSupplement" placeholder="商品名称补充语，最多15个字"></el-input>
                <div class="name-preview">
                  <span class="tips">完整名称效果：</span>
                  <template v-if="self_form.productNameSupplementSeq === 1">
                    {{self_form.productNameSupplement}}{{self_form.name}}
                  </template>
                  <template v-else>
                    {{self_form.name}}{{self_form.productNameSupplement}}
                  </template>
                  <el-button type="text" @click="toggleSupplementPosition">
                    切换为{{ self_form.productNameSupplementSeq === 1 ? '后置' : '前置' }}补充语
                  </el-button>
                </div>
                <!-- <span class="tips">完整名称效果：</span> {{self_form.name}}{{self_form.productNameSupplement}}  -->
              </div>
            </div>
          </el-form-item>

          <el-form-item v-if="!self_form.upc" label="商品图片：" prop="picture">
            <div class="imgs-wrp">
              <div class="ft-12">展示时只取主图，拖动可调整顺序<BatchEditImages v-model="self_form.picture"></BatchEditImages></div>
              <MutiImgUpload
                ref="picture"
                v-model="self_form.picture"
                :limitSize="8 * 1024 * 1024"
                :aspectRatio="[1,0.75]"
                aspectRatioText="1:1或3:4"
                :aspectRatioLimitWidth="[[800, 0], [750, 0]]"
                :limitNums="9"
                :mainImgNums="0"
                itemSizeStyle=""
                limitSuffix=".jpg,.png,.jpeg"
                :supportAiRetry="true"
              />
            </div>
          </el-form-item>

          <el-form-item v-if="self_mtRapidType == 2"  label="商品类目：" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :platform="platform" />
            </div>
          </el-form-item>
          <el-form-item v-show="self_form.categoryIds && self_form.categoryIds.length && self_mtRapidType == 2" label="商品类目属性:">
            <CategoryProps
              ref="cateprops"
              :shopId="shopId"
              :categoryType="self_mtRapidType"
              v-model="self_form.commonAttrValue"
              :categoryIds="self_form.categoryIds"/>
          </el-form-item>
          <!-- 医药类商品类目仅仅展示作用 -->
          <el-form-item v-if="this.self_mtRapidType == 1" label="商品类目：" prop="categoryName">
            <div class="category ft-12">
              <el-input disabled v-model="self_form.categoryName"></el-input>
            </div>
          </el-form-item>
          <div class="conf" v-if="this.self_mtRapidType == 2">
            <el-form-item label="商品资质图：" prop="quaPictures">
              <!-- <ImgUpload
                ref="quaPictures"
                :file="self_form.quaPictures"
                :limitSize="3 * 1024 * 1024"
                :limitWidth="[800, 0]"
                :limitHeight="[800, 0]"
                limitSuffix=".png"
                :isSingle="true"
                @upload-success="(url) => (self_form.quaPictures=url)"
                @del="() => (self_form.quaPictures = '')"
              /> -->
              <MutiImgUpload
                ref="quaPictures"
                v-model="self_form.quaPictures"
                :limitSize="3 * 1024 * 1024"
                :limitWidth="[800, 0]"
                :limitHeight="[800, 0]"
                :aspectRatio="[1,1]"
                aspectRatioText="1:1"
                :aspectRatioLimitWidth="[[800, 0], [800, 0]]"
                :limitNums="3"
                :mainImgNums="0"
                itemSizeStyle=""
                limitSuffix=".jpg,.png,.jpeg"
              />
            </el-form-item>
            <el-form-item>
              <div class="tips ft-12">
                <div>
                  医疗器械商品必上传医疗器械注册证或备案凭证图
                </div>
                <div>
                  保健食品请上传保健注册批件图
                </div>
                  <div>
                    特殊医学用途配方食品、婴幼儿配方乳粉请上传注册证书图
                  </div>
                <div>
                  图片支持1 : 1，格式：JPG/PNG/JPEG，最多上传3张图，每张图大小不可超过3M
                </div>
              </div>
            </el-form-item>
            <el-form-item label="批准日期">
              <el-date-picker
                style="width: 265px !important"
                v-model="self_form.quaApprovalDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="'请选择批准日期'"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="有效期至">
              <el-radio-group v-model="expireTimeRadioValue" @change="handleExpireTimeChange">
                  <el-radio :label="1">
                      <el-date-picker
                        style="width: 265px !important"
                        v-model="effectiveDateValue"
                        type="datetime"
                        @change="handleDatePickerChange"
                        value-format="yyyy-MM-dd"
                        :placeholder="'请选择有效期'"
                      ></el-date-picker>
                  </el-radio>
                  <el-radio :label="-1">长期有效</el-radio>
                </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item v-if="self_mtRapidType == 2" label="店内分类：" prop="categoryName">
            <div class="imgs-wrp">
              <el-select
                  v-model="self_form.categoryName"
                  :collapseTags="true"
                  :filterable="true"
                  :clearable="true"
                  placeholder="请选择"
              >
                  <el-option v-for="item in retailCategoryData" :value="item.name" :label="item.name" :key="item.value"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item v-if="false" label="封面视频:">
            <el-row style="display: flex; align-items: center;">
              <VideoUpload :video="self_form.videoId" aspectRatio="1:1,3:4,16:9" :limitDuration="60" :limitTitle="64" @upload-success="v => handleVideo(v, 1)" @del="v => handleVideo(v, 0)"/>
            </el-row>
            <div class="ft-12 tips">
              <div>
                视频尺寸建议为1:1、3:4、16:9，支持上传200MB以内.mp4(推荐)/.mov/.wmv/.avi/.mpg/.mpeg等格式视频。
              </div>
              <div>
                封面视频可使顾客更好地了解商品，进而提升商品销量
              </div>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>售卖信息</span>
        </div>
        <el-form-item v-if="this.self_mtRapidType === 1" style="margin-top: 16px;">
          <SKUInfoTable v-model="self_form.skuInfo" />
        </el-form-item>
         <div class="conf"  props="categoryIds">
          <el-form-item v-if="this.self_mtRapidType === 2" label="商品规格：" :rules="[{required: true, message:'请填写商品规格'}]">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification 
             ref="specificationRef" 
             v-model="specifications"
             :variations="variations" 
             :changeToBase="changeToBase" 
             :isPlatform="true" 
             :platform="platform" 
             @fieldChanged="specificationsFieldChanged"
             />
          </el-form-item>
          <el-form-item v-if="this.self_mtRapidType === 2" label="规格明细：">
            <FormItemSkuList
              :specifications="specifications"
              skuSpecificationsKey="skuSpecifications"
              :tableCols="skuTableCols"
              @fieldChanged="specificationsFieldChanged"
              v-model="skuList"
              :isYyjk="true"
            >
              <template slot="weightForUnitSlot" slot-scope="{ row }">
                <div style="display: flex; align-items: center;">
                  <el-input
                    v-model="row.weightForUnit"
                    :controls="true"
                    style="width: 100px" 
                  ></el-input>
                  <el-select 
                    v-model="row.weightUnit" 
                    style="width: 100px; margin-left: 8px;"
                    placeholder="单位">
                    <el-option label="克(g)" value="克(g)"></el-option>
                    <el-option label="千克(kg)" value="千克(kg)"></el-option>
                    <el-option label="毫升(ml)" value="毫升(ml)"></el-option>
                    <el-option label="升(L)" value="升(L)"></el-option>
                    <el-option label="斤" value="斤"></el-option>
                    <el-option label="磅" value="磅"></el-option>
                  </el-select>
                </div>
              </template>
            </FormItemSkuList>
            <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{specificationsValidResult}}</div>
            </template>
          </el-form-item>
        </div>
          <el-form-item v-if="this.self_mtRapidType == 2" label="文字详情：">
            <el-input v-model="self_form.description"></el-input>
         </el-form-item>
        <el-form-item v-if="this.self_mtRapidType == 2" label="商品详情图：">
          <div class="imgs-wrp">
            <div class="ft-12"><BatchEditImages v-model="self_form.pictureContents"></BatchEditImages></div>
            <MutiImgUpload
              v-model="self_form.pictureContents"
              :mainImgNums="0" 
              :limitSize="2 * 1024 * 1024"
              :supportAiRetry="true"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="this.self_mtRapidType == 2">
          <div class="tips ft-12">建议图片宽度≥640像素，高度≥960像素；单张图片2M以内</div>
        </el-form-item>
        <div>
          <el-form-item label="商品最近有效期">
            <el-date-picker
              style="width: 265px !important"
              v-model="self_form.expiryDate"
              type="datetime"
              value-format="yyyy-MM-dd"
              :placeholder="'请选择商品最近有效期'"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div>
                平台强管控特殊商品必填最近有效期，如保存商品时被提醒此字段不可为空，则为强管控特殊商品，请补充此信息后重新操作保存；
              </div>
              <div>
                举例：如商家库存商品最近有效期为2022.06.30，商家需填写维护日期为2022.06.30
              </div>
              <div>
                平台针对医药商品保质期管理规则，具体参考美团买药商家规则中心-《美团买药即时零售业务商品保质期管理规范》，《美团买药快递电商业务商品保质期管理规范》
              </div>
            </div>
          </el-form-item>
        </div>
      </section>
    
      <section>
        <div class="title ft-12">
          <span>高级设置</span>
        </div>
        <div class="conf">
          <el-form-item v-if="this.self_mtRapidType == 2" label="商品标签:" prop="productTag">
            <el-checkbox v-model="self_form.isSpecialty">力荐</el-checkbox>
          </el-form-item> 
        <el-form-item prop="limitSaleInfo"> 
          </el-form-item>
          <el-form-item v-if="this.self_mtRapidType == 2" label="商品属性：">
            <PropertyEditor :spuId="self_form.id" v-model="self_form.properties" ref="propertyEditor" />
          </el-form-item>
          <el-form-item v-if="this.self_mtRapidType == 2" label="运费模版:" prop="shelfState">
            <el-select
                  v-model="self_form.shopCategory"
                  :collapseTags="true"
                  :filterable="true"
                  :clearable="true"
                  placeholder="品牌"
              >
                  <el-option v-for="item in shopCategoryList" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
          </el-form-item>
          <LimitSaleForm v-model="self_form.limitSaleInfoDto" />
          <el-form-item label="上架设置:" prop="isSoldOut" :rules="[{ required: true, message: '请选择上架设置' }]">
            <el-radio-group v-model="self_form.isSoldOut">
              <el-radio :label="0">上架</el-radio>
              <el-radio :label="1">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
      </template>
    </el-form>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import ImgUpload from "@/components/Uploads/ImgUpload";
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import VideoUpload from '@/components/Uploads/videoUpload'
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import CategoryInput from '../PlatformCategoryInput/index.vue';
import ReuseLastCategory from '../PlatformCategoryInput/ReuseLastCategory.vue';
import CategoryProps from './CategoryProps.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import BrandIdBlock from './BrandIdBlock.vue';
import LogisticsBlock from './LogisticsBlock.vue';
import TemplateBlock from './TemplateBlock.vue';
import FormItemSpecification from './FormItemSpecification';

import RULES from './rules.js';
import {validateSkuPrice} from '../DdianInfoForm/rules';

import { specification_mixin } from '../FormItemSpecification';
import { logisticsList, getXhsDeliveryRule, getMappingVariations, variations, editCarouselVideo } from '@/servers/prod/center/xhs.js';
import { getMtDetail,editYyjkInfo,getShopCategoryList } from '@/servers/prod/center/mt.js'
import { getDistributionConfig } from "@servers/prod/conf/index.js";
import validateMixin from '../validateMixin';
import dayjs from 'dayjs';
import PropertyEditor from './components/productProperties.vue'
import ShippingTime from './components/shippingTime.vue'
// import ImageUploadPreview from './components/ImageUploadPreview.vue'
import LimitSaleForm from './components/LimitSaleForm.vue';
// import SKUInfoTable from './components/SKUInfoTable.vue';
import SKUInfoTable from './components/SkuInfoTable.vue';

export default {
  mixins: [specification_mixin, validateMixin],
  provide: {
    platform: 'yyjk',
  },
  inject: {
    isGroupPuhuo: { default: false },
    handleDownloadFormPlatform: {
      default: () => {
        console.warn('handleDownloadFormPlatform not provided');
        return () => {};
      }
    }
  },
  components: {
    ImgUpload,
    MutiImgUpload,
    VideoUpload,
    BatchEditImages,
    CategoryInput,
    ReuseLastCategory,
    CategoryProps,
    UseCategoryTemplate,
    BrandIdBlock,
    LogisticsBlock,
    TemplateBlock,
    FormItemSpecification,
    PropertyEditor,
    ShippingTime,
    // ImageUploadPreview,
    LimitSaleForm,
    SKUInfoTable,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    mtRapidType: [Number, String],
  },
  data() {
    return {
      effectiveDateValue: dayjs().format('YYYY-MM-DD'), // 单独管理日期选择器的值 
        // expireTimeRadioValue: 1, // 1=指定日期, -1=长期有效 
        expireTimeOptions: [
        { label: '指定日期', value: 1 },
        { label: '长期有效', value: -1 }
      ],
      shopCategoryList:'',
      platform: 'yyjk',
      self_form: {
        // productType: 1,
        // medicineType: 1,
        upcCode:'',
      },
      rules: RULES(this),
      skuTableCols: [
        { prop: 'upc', attrs: { label: '条形码',noRequired:true }, input: { type: 'number' } },
        { prop: 'price',attrs: { label: '价格' }, input: { type: 'number', validator: validateSkuPrice} },
        {
          prop: 'stock',
          attrs: { label: '库存' },
          input: { type: 'number' },
          disabledFn: row => {
            return this.form?.pureType || row.stockType === 1;
          },
        },
        {
            prop: 'weightForUnit',
            validate: true,
            attrs: {label: '重量',width: 200,},
            slot: 'weightForUnitSlot',  // 添加自定义slot
        },
        { prop: 'skuId', validate: true, attrs: { label: '店内码/货号',}, input: { type: 'text'} },
        { prop: 'locationCode', attrs: { label: '货架码/位置',noRequired: true }, input: { type: 'text' }, },
      ],
      skuSpecificationsKey: 'skuSpecifications',
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: false, // 规格需要校验图片是否补充
      shopList: [],
      shipsTemplate: null, // 运费模板列表
      shipsValue: null, // 运费模板值
      // templateConfigMap: null, // 初始值
      faqList:[{
        question:'',
        answer:''
      }],
      logisticsPlanId: '',
      variations:[], // 规格列表
      existingList: [],
      relativePre: {},
      absolutePre: {},
      skuDeliveryOptions: [],
      retailCategoryData: [],
      oldSelfForm:{
        baseItemId:''
      },
      self_mtRapidType:'',
    };
  },
  watch: {
    form: {
      handler(v) {
        if(v.baseItemId){
          this.oldSelfForm.baseItemId = v.baseItemId
        }
        this.handleSkuList(v.skuList)
        this.faqList = v.faqList || [{question:'',answer:''}];
        if(this.mtRapidType == 2){
          this.specifications = v.specifications?.length ? v.specifications : []
        } else {
          this.specifications = v.specifications?.length ? JSON.parse(JSON.stringify(v.skuInfo)) : []
        }
        this.initFormDateData(v)

        v.shopId && this.getShopCategory(v.shopId)
        console.log(JSON.parse(JSON.stringify(v)), '-----fff---')
        this.$set(this, 'self_form', {
          ...v,
        });
        this.$nextTick(() => {
          this.validPage();
        });
      },
      immediate: true,
    },
    categoryId:{
      async handler(v) {
        if(v) {
          // this.getMapSku()
          // 获取美团数据
          // 获取物流方案
          // await this.getLogisticsList();
          // await this.getDeliveryRules();
          // 通过店铺ID获取店内分类数据
          // await this.getTypeDataFromShop()
        }
      },
      immediate: true,
    },
    // 'self_form.medicineType':{
    //    handler(v) {
    //     if (v == 2) {
    //       // 切换到医药类时清空表单
    //       this.clearFormData();
    //     }
    //   },
    //   immediate: true,
    // },
    mtRapidType: {
      handler(newVal, oldVal) {
        this.self_mtRapidType = newVal
      },
      immediate: true 
    },
    self_mtRapidType: {
      handler(newVal,oldVal){
        if (newVal !== oldVal) {
        // 更新本地存储 
        localStorage.setItem('mtRapidType',  newVal); 
        
        // 重置表单数据 
        this.clearFormData(); 
        
        // 获取新类型的数据 
         this.getMtData(); 
        
        // 强制更新视图 
        this.$forceUpdate();
        }
      },
    },
    // 监听表单初始值变化 
    'self_form.quaEffectiveDate':  {
      immediate: true,
      handler(newVal) {
        if (newVal === "-1" || newVal === -1) {
          this.expireTimeRadioValue  = -1;
          this.effectiveDateValue  = '';
        } else if (newVal) {
          this.expireTimeRadioValue  = 1;
          // 确保日期格式正确 
          const validDate = dayjs(newVal).isValid() 
            ? dayjs(newVal).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD');
          this.effectiveDateValue  = validDate;
        } else {
          // 默认值处理 
          this.expireTimeRadioValue  = 1;
          this.effectiveDateValue  = dayjs().format('YYYY-MM-DD');
        }
      }
    },
  },
  computed: {
    expireTimeRadioValue: {
      get() {
        return this.self_form.quaEffectiveDate  === -1 ? -1 : 1;
      },
      set(val) {
        if (val === -1) {
          this.self_form.quaEffectiveDate  = -1;
          // 强制清空日期选择器的值 
          this.$nextTick(() => {
            this.self_form.quaEffectiveDate  = -1;
          });
        } else {
          this.self_form.quaEffectiveDate  = dayjs().format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    titleLength() {
      const goodsName = this.self_form.name || '';
      return this.getLenWith(goodsName);
    },
    categoryId() {
      let categoryIds = this.self_form.categoryIds || [];
      return categoryIds.length ? categoryIds[categoryIds.length - 1] : '';
    },
    shopId() {
      return  this.$store.getters.shops_getCategoryPropShopId('yyjk')
    },
    pickerOptions() {
      const self = this;
      return {
        disabledDate(time) {
          const curTime = dayjs(time).valueOf();
          const maxTime = Date.now() + (self.absolutePre?.max || 0) * 3600000
          const minTime = Date.now() + (self.absolutePre?.min - 24 || 0) * 3600000
          return curTime > maxTime || curTime < minTime;
        },
      };
    },

  },

  methods: {
    initFormDateData(data) {
        if (data.quaEffectiveDate === -1 || data.quaEffectiveDate === '-1' || data.quaEffectiveDate === null) {
          this.self_form.quaEffectiveDate = -1;
          this.expireTimeRadioValue = -1; // 确保设置单选按钮状态
          // 强制更新单选按钮状态
          this.$nextTick(() => {
            this.expireTimeRadioValue = -1;
          });
        } else if (data.quaEffectiveDate) {
          // 确保日期格式正确
          const validDate = dayjs(data.quaEffectiveDate).isValid()
            ? dayjs(data.quaEffectiveDate).format('YYYY-MM-DD HH:mm:ss')
            : dayjs().format('YYYY-MM-DD HH:mm:ss');
          this.self_form.quaEffectiveDate = validDate;
          this.expireTimeRadioValue = 1; // 确保设置单选按钮状态
          // 强制更新日期选择器值
          this.$nextTick(() => {
            this.self_form.quaEffectiveDate = validDate;
          });
        } else {
          // 默认值处理
          const currentDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
          this.self_form.quaEffectiveDate = currentDate;
          this.expireTimeRadioValue = 1; // 确保设置单选按钮状态
          // 强制更新日期选择器值
          this.$nextTick(() => {
            this.self_form.quaEffectiveDate = currentDate;
          });
        }
      },
      handleExpireTimeChange(val) {
        if (val === -1) {
          // 选择"长期有效"时清空日期值 
          this.effectiveDateValue  = '';
          this.self_form.quaEffectiveDate  = "-1";
        } else {
          // 选择"指定日期"时设置默认值 
          if (!this.effectiveDateValue)  {
            this.effectiveDateValue  = dayjs().format('YYYY-MM-DD');
          }
          this.self_form.quaEffectiveDate  = this.effectiveDateValue; 
        }
      },
        // 处理日期选择器变化 
        handleDatePickerChange(date) {
          if (date) {
            // 当选择日期时，自动更新表单值 
            this.self_form.quaEffectiveDate  = date;
          } else if (this.expireTimeRadioValue  === 1) {
            // 如果清空日期且当前是"指定日期"选项，重置为当前日期 
            const currentDate = dayjs().format('YYYY-MM-DD');
            this.effectiveDateValue  = currentDate;
            this.self_form.quaEffectiveDate  = currentDate;
          }
        },

    async getShopCategory(shopId){
      const res = await getShopCategoryList({shopId:shopId || this.self_form.shopId})
      if(res.success){
        this.retailCategoryData = res.retailCategoryData?.length ? res.retailCategoryData : []
      }
    },
    toggleSupplementPosition() {
      this.self_form.productNameSupplementSeq = this.self_form.productNameSupplementSeq === 1 ? 0 : 1;
    },
    handleDownProduct(){
      if (typeof this.handleDownloadFormPlatform === 'function') {
        this.handleDownloadFormPlatform();
      } else {
        console.warn('handleDownloadFormPlatform is not a function');
      }
    },
    clearFormData() {
      // 保留必要字段，清空其他数据
      // const medicineType = this.self_form.medicineType;
      const upcCode = this.self_form.upcCode;
      this.self_form = {
        upcCode,
        categoryIds: [],
        specifications: [],
        skuList: [],
        attributeList: [],
      };
      this.specifications = [];
      this.faqList = [{
        question: '',
        answer: '' 
      }];
    },
    handleMatchUPC(){
      const res = 1
      if(res){
        // this.self_form.upcCode = res
      }
    },
    handleSkuList(skuList=[]) {
      skuList.map(item => {
        const skuSpecifications = Array.isArray(item.skuSpecifications) ? item.skuSpecifications : JSON.parse(item.skuSpecifications)
        const _skuid = skuSpecifications.map((sp) => sp.valueKey).filter(Boolean).join("-");
        item.skuSpecifications = skuSpecifications;
        item._skuid = _skuid;
      });
      return skuList
    },
    getLenWith(text) {
        const arr = text.split('');
        let reg = /[\u4e00-\u9fa5]/;
        return arr.reduce((acc, ch) => {
            if (reg.test(ch)) {
                return acc + 2;
            }
            return acc + 1;
        }, 0)
    },

    updateRefundRule(categoryConfig) {
      this.categoryConfig = this.$set(this, 'categoryConfig', categoryConfig);
      const servicePromises = [
          {key: 'freshRotRefund', label: '坏了包退'}, 
          {key: 'brokenRefund', label: '破损包退'}, 
          {key: 'allergyRefund', label: '过敏包退'}, 
      ];
      this.servicePromiseSelectList = servicePromises.filter(promise => {
        const configVal = categoryConfig[promise.key];
        if(configVal === undefined) return false;
        promise.disabled = false;
        if(configVal === '0') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = false;
        } else if(configVal === '2') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = true;
        }
        return true;
      })
      const newRefundRule = categoryConfig.refundRuleList || [];
      this.refundRuleOptions = refundRuleList.filter(item => newRefundRule.includes(item.value))
      if (this.self_form.refundRule && newRefundRule.includes(this.self_form.refundRule)) {
        return ;
      }
      this.self_form.refundRule = newRefundRule.length ? newRefundRule[0] : ''
    },

    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        if (this.$refs.specificationRef) {
          const specificationValid = await this.$refs.specificationRef.validateSpecValueForm();
          if (!specificationValid) {
            this.$message.error('请检查商品规格信息是否正确维护');
            resolve(false);
            return;
          }
        }
        if (this.$refs.propertyEditor) {
          const specificationValid = await this.$refs.propertyEditor.getData();
          if (!specificationValid) {
            this.$message.error('请检查商品属性信息是否正确维护');
            resolve(false);
            return;
          }
        }
        this.validPage().then(valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resolve(false);
            return false;
          }

          // const c_names = this.$refs.cinput.method_getCategoryNames();
          let _formdata = JSON.parse(JSON.stringify(this.self_form));
          const [specifications, skuList] = this.getSpecificationData();
     
          // skuList.forEach(sku => {
          //   let { selectValue = '', time=null, type=null, option } = sku.deliveryTimeObject || {}
          //   let strSelectVal = selectValue.join(',')
          //   if(strSelectVal === '0,0') {
          //     option = 0;
          //     time = '0';
          //     type = 'TODAY';
          //   } else if(strSelectVal === '0,1') {
          //     option = 0;
          //     time = '1';
          //     type = 'RELATIVE_TIME_NEW';
          //   } else if(strSelectVal === '0,2') {
          //     option = 0;
          //     time = '2';
          //     type = 'RELATIVE_TIME_NEW';
          //   } else if(strSelectVal === '1,1') {
          //     option = 1;
          //     type = 'RELATIVE_TIME_NEW';
          //   } else if(strSelectVal === '1,2') {
          //     option = 2;
          //     type = 'ABSOLUTE_TIME_NEW';
          //     time = time.replaceAll('-', '/')
          //   } 
          //   sku.deliveryTimeObject = {
          //     time, 
          //     option,
          //     type
          //   }
          // })
          _formdata.specifications = specifications;
          _formdata.skuList = skuList;
          console.log(this.self_form.quaEffectiveDate,713)
          _formdata.quaEffectiveDate = this.expireTimeRadioValue  === -1 ? "-1" : this.effectiveDateValue 
          _formdata.tagId = this.categoryId;
          // _formdata.categoryName = c_names[c_names.length - 1];
          // _formdata.parentCategoryName = c_names[c_names.length - 2];
          // _formdata.shopId = this.shopId;
          // _formdata.faqList = this.faqList;
          // _formdata.logisticsPlanId = this.logisticsPlanId || '';
          // if(_formdata.deliveryTimeObject.option === 2 && _formdata.deliveryTimeObject.time) {
          //   _formdata.deliveryTimeObject.time = _formdata.deliveryTimeObject.time.replaceAll('-', '/')
          // }
          // 提交表单
          console.log(_formdata, '-----_formdata----')
          // resolve(false);
          // return
          resolve(_formdata);
        });
      });
    },
    // 上传视频
    async handleVideo(value, type) {
      // type 0 删除 1 成功
      this.self_form.videoVo = type === 1 ? { ...value } : null;
      this.self_form.videoId = null;
      this.self_form.videoUrl = ''
      if(this.self_form.videoVo) {
        const videoId = await editCarouselVideo({
          carouselVideoVo: this.self_form.videoVo,
          baseItemId: this.self_form.baseItemId
        });
        this.self_form.videoUrl = value.originUrl
        this.self_form.videoId = videoId
      }
    },
    isParseTrue(time) {
      return time === '' || String(time).includes('-')
    },
    // skuDeliveryTimeChange(value, deliveryTimeObject) {
    //   deliveryTimeObject.time = ''
    // },
    // deliveryTimeObjectChange(value) {
    //   if(value === 0) {
    //     this.self_form.deliveryTimeObject.time = '2'
    //   } else if(value === 3) {
    //     this.self_form.deliveryTimeObject.type = null
    //     this.self_form.deliveryTimeObject.time = ''
    //   } else {
    //     this.self_form.deliveryTimeObject.time = ''
    //   }
    //   this.deliveryTimeChange(this.self_form.deliveryTimeObject.time)
    //   this.isShowSkuDeliveryTime()
    // },
    // isShowSkuDeliveryTime() {
    //   this.skuTableCols.forEach(col => {
    //     if(col.prop == 'deliveryTime') {
    //       col.unvisible = this.self_form.deliveryTimeObject.option !== 3
    //     }
    //   })
    // },
    // deliveryTimeChange(v) {
    //   const option = this.self_form.deliveryTimeObject.option
    //   let type = null
    //   if(option == 0) {
    //     type = v === '0' ? 'TODAY' : 'RELATIVE_TIME_NEW'
    //   } else if (option == 1) {
    //     type = 'RELATIVE_TIME_NEW'
    //   } else if (option == 2) {
    //     type = 'ABSOLUTE_TIME_NEW'
    //   }
    //   this.self_form.deliveryTimeObject.type = type || null
    // },
    // 获取物流方案
    // async getLogisticsList() {
    //   if(this.logisticsPlanId) return
    //   const res = await logisticsList();
    //   const logisticsPlans = res.data?.logisticsPlans || [];
    //   if (logisticsPlans.length) {
    //     this.logisticsPlanId = logisticsPlans[0].planInfoId || '';
    //   }
    // },
    // 获取发货方式规则
    // async getDeliveryRules() {
    //   if(!this.shopId || !this.logisticsPlanId) return
    //   const res = await getXhsDeliveryRule({
    //     shopId: this.shopId,
    //     categoryId: this.categoryId,
    //     logisticsPlanId: this.logisticsPlanId
    //   });
    //   const skuExistingChildren = []
    //   const existing = res.existing || [];
    //   const presale = res.presale || [];
    //   const existingList = existing.map(item => {
    //     let type = '';
    //     let label = '';
    //     let time = '';
    //     if(item.timeType === 3) {
    //       label = '当日发货';
    //       type = 'TODAY';
    //       time = '0'
    //     } else {
    //       label = item.value + '小时';
    //       type = 'RELATIVE_TIME_NEW';
    //       time = String(item.value / 24)
    //     }
    //     skuExistingChildren.push({
    //       value: time,
    //       label,
    //       type
    //     })

    //     return {
    //       type,
    //       label,
    //       time,
    //       ...item
    //     }
    //   })
    //   const relativePre = presale.find(item => item.timeType === 4)  // 时段预售（相对时间）
    //   const absolutePre = presale.find(item => item.timeType === 5)  // 定时预售（绝对时间）
    //   this.existingList = existingList;
    //   this.relativePre = { ...relativePre, min: relativePre.min / 24, max: relativePre.max / 24};
    //   this.absolutePre = absolutePre;

    //   this.skuDeliveryOptions = [
    //     {
    //       value: 0,
    //       label: '非预售',
    //       children: skuExistingChildren
    //     },
    //     {
    //       value: 1,
    //       label: '预售',
    //       children: [
    //         {
    //           value: 1,
    //           label: '时段预售',
    //           type: 'RELATIVE_TIME_NEW'
    //         },
    //         {
    //           value: 2,
    //           label: '定时预售',
    //           type: 'ABSOLUTE_TIME_NEW'
    //         }
    //       ]
    //     },
    //   ]
      
    // },
    //添加问题
    addQuestion(){
      this.faqList.push({
        question:'',
        answer:''
      })
    },
    // 删除问题
    deleteQuestion(index){
      this.faqList.splice(index, 1);
    },
    // getTypeDataFromShop(){
    //   const res =  [{
    //       value: '选项1',
    //       label: '黄金糕'
    //     }, {
    //       value: '选项2',
    //       label: '双皮奶'
    //     }, {
    //       value: '选项3',
    //       label: '蚵仔煎'
    //     }, {
    //       value: '选项4',
    //       label: '龙须面'
    //     }, {
    //       value: '选项5',
    //       label: '北京烤鸭'
    //     }]
    //     this.shopCategoryList = res
    //     return res
    // },
    //获取规格映射
    // getMapSku() {
    //   if (this.categoryId) {
    //     let varParams = {
    //       leafCategoryId: this.categoryId,
    //       shopId: this.shopId,
    //     };

    //     variations(varParams).then(res => {
    //       this.variations = res.data.variations;
    //       let variationsVals = this.variations.map(i => i.id);
    //       // 如改了类目，没改规格名，保存后，还是会存在没匹配的情况
    //       if (!variationsVals.includes(this.specifications[0]?.nameKey) || !variationsVals.includes(this.specifications[1]?.nameKey)) {
    //         this.skuMapTwoValue();
    //       }
    //     });
    //   }
    // },


    async getMtData() {
      
      try {
        const params = {
          baseItemId: this.self_form.baseItemId  || this.oldSelfForm.baseItemId || this.baseItemId, 
          mtRapidType: this.self_mtRapidType, 
        };
        
        const data = await getMtDetail(params);
        if (data?.baseItemId) {
          // 处理规格数据 
          if (this.self_mtRapidType  == 2) {
            // 非药类商品 
            this.specifications  = data.specifications?.length  
              ? data.specifications  
              : []; 
          } else {
            // 医药类商品 
            this.specifications  = data.skuInfo?.length  
              ? JSON.parse(JSON.stringify(data.skuInfo)) 
              : []; 
          }
          
          // 处理SKU列表 
          this.skuList  = this.handleSkuList(data.skuList  || []);
          
          // 更新表单数据 
          this.$set(this, 'self_form', {
            ...data,
            specifications: this.specifications, 
            skuList: this.skuList  
          });
          
          // 其他处理...
        } else {
          // 初始化空数据 
          // this.initEmptyData(); 
        }
      } catch (error) {
        console.error(' 获取商品详情失败:', error);
        this.$message.error(' 获取商品详情失败');
        // this.initEmptyData(); 
      }
    },
    clickTemPlateFill(row) {
      const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : []
      this.self_form.attributeList = platformCatProp
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: "yyjk" });
      // 上架设置
      this.self_form.shelfState = this.form.shelfState ? this.form.shelfState : (res?.shelfState || 2);
    },
    // 处理长期有效切换 
    handleLongTermChange(val) {
      if (val === -1) {
        // 选择长期有效时清空日期 
        this.self_form.quaEffectiveDate  = '';
        this.self_form.isLongTerm  = true;
      } else {
        // 选择日期选择器时
        this.self_form.isLongTerm  = false;
      }
    },

  },
  mounted() {

     // 示例数据
     const propertyData = [
      {
        id: 30950325945,
        spuId: 17843282831,
        no: 0,
        name: "test",
        value: "1"
      },
      // ... 其他数据
    ];
    
    // 初始化属性编辑器
    // this.getConf();
    // const shopList = this.$store.getters.get_AllShops_BySource('xhs');
    // this.shopList = shopList;
  },
};
</script>

<style lang="scss" scope>
a{
  color:#6189f5;
  text-decoration: none;
}
.no-specifications{
  display: flex;
  justify-content: center;
  align-items: center;
  margin:20px;
  color:#ccc;
}
.name-preview {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>
